module.exports = __webpack_public_path__ + "static/media/image3.600caf9d.jpg";